/*
 * W12: text outside React — enum codes shown through a module's `humanize()` (`ON_HOLD` → "On hold") and the field
 * labels a server's search registry sends ("Carrier") — in the viewer's language. The I18nProvider keeps the translator
 * current; the catalogue holds `code.<CODE>` and `field.<slug>` entries. A missing entry keeps the caller's English.
 */
let current: ((key: string) => string | undefined) | null = null;

/** Called by the I18nProvider on every render with the translator of the language in view. */
export function setStaticTranslator(translate: ((key: string) => string | undefined) | null): void {
  current = translate;
}

/** `code.SALES` in the viewer's language, or undefined when the catalogue has none. */
export function translateCode(code: string | null | undefined): string | undefined {
  if (!code || !current) return undefined;
  return current(`code.${code}`);
}

/** The catalogue key of a server field label: "Transport mode" → `field.transport-mode`. */
export function fieldLabelKey(label: string): string {
  return `field.${label.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
}

/** A server-sent field label in the viewer's language, else the server's text. */
export function serverLabel(label: string): string {
  if (!label || !current) return label;
  return current(fieldLabelKey(label)) ?? label;
}

/**
 * L-14 (R1): a platform-seeded role's name in the viewer's language (`role.system.<CODE>`), else the name the server sent.
 * Tenant-defined roles are the tenant's own text and pass through.
 */
export function roleName(code: string | null | undefined, name: string): string {
  if (!code || !current) return name;
  return current(`role.system.${code}`) ?? name;
}
